import { useState } from 'react'
import { CustomerCouponCode, customerData } from '../../../utilities/CustomerData'
import { apiURL } from '../../../utilities/URLs'
import { refreshAccessToken } from '../../../utilities/extensions'
import { useNavigate } from 'react-router-dom'

export function DashboardDiscountCode() {
  const navigate = useNavigate()
  const [discountCode, setDiscountCode] = useState(customerData.customerCouponCode)
  const [inputCode, setInputCode] = useState('')
  const [applyingCouponCode, setApplyingCouponCode] = useState(false)
  const [error, setError] = useState('')

  const handleApplyCoupon = async () => {
    setApplyingCouponCode(true)

    const form = new FormData()
    form.append('couponInfo', JSON.stringify({
      customerId: customerData.customerLeadData.leadContact.contactId,
      couponCode: inputCode,
      couponType: 'Before'
    }))

    const couponCodeResponse = await fetch(`${apiURL}/api/checkCouponCode`, {
      method: 'POST',
      headers: {
        'Authorization': customerData.accessToken
      },
      body: form
    })
    const couponCodeData = await couponCodeResponse.json()
    setApplyingCouponCode(false)
    if (couponCodeData.response.error) {
      if (couponCodeData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleApplyCoupon() : navigate('/', { state: { expired: true } })
      } else {
        setError(couponCodeData.response.error)
        setTimeout(() => {
          setError('')
        }, 3000)
      }
    } else {
      const discountCode = new CustomerCouponCode({
        customerId: customerData.customerLeadData.leadContact.contactId,
        couponCode: couponCodeData.response.couponCode.couponCode,
        couponAmount: couponCodeData.response.couponCode.couponAmount,
        couponType: couponCodeData.response.couponCode.couponType
      })
      customerData.customerCouponCode = discountCode
      setDiscountCode(discountCode)
    }
  }

  return (
    <div className='shadow-lg rounded-2xl p-6 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-white mb-10'>
      {!discountCode.customerId ? (
        <div className='flex flex-col p-6'>
          <h2 className='text-lg font-bold text-gray-800 mb-6 text-center lg:text-left'>
            Apply a discount code to reduce your processing fee once you get your refund
          </h2>
          <div className='flex flex-col lg:flex-row items-center justify-between w-full'>
            <input
              type='text'
              placeholder='Enter discount code'
              value={inputCode}
              onChange={(e) => setInputCode(e.target.value)}
              className='p-3 border border-gray-300 rounded-lg shadow-md w-full lg:w-3/4 mb-4 lg:mb-0 transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
            <button
              disabled={!inputCode}
              onClick={handleApplyCoupon}
              className={`${inputCode ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-400 cursor-not-allowed'} text-white px-6 py-3 rounded-lg w-full lg:w-auto mt-2 lg:mt-0 lg:ml-4 shadow-lg transition duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-400`}
            >
              Apply Discount
            </button>
          </div>
          {applyingCouponCode && (
            <div className='flex flex-row items-center justify-center gap-2 mt-4'>
              <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] h-8 w-8'></div>
              <p className='text-gray-600'>Applying Coupon Code...</p>
            </div>
          )}
          {error && (
            <p className='text-red-700 mt-10'>{error}</p>
          )}
        </div>
      ) : (
        <div className='flex flex-col p-6'>
          <h2 className='text-2xl font-bold text-gray-800 mb-6 text-center lg:text-left'>Here is your applied coupon code!</h2>
          <div className='bg-gray-100 p-5 rounded-lg shadow-lg'>
            <p className='text-lg font-semibold text-gray-700'>
              <strong>Coupon Code:</strong> {discountCode.couponCode}
            </p>
            <p className='text-lg font-semibold text-gray-700 mt-2'>
              <strong>Discount:</strong> {discountCode.couponAmount > 1 ? `$${discountCode.couponAmount} dollars off your process fee` : `${discountCode.couponAmount * 100}% off your processing fee`}
            </p>
          </div>
        </div>
      )}
    </div>
  )
}
